import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, isSupported } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

const requiredKeys = ['apiKey', 'authDomain', 'projectId', 'appId'];
const hasRequiredFirebaseConfig = requiredKeys.every((key) => {
  const value = firebaseConfig[key];
  return typeof value === 'string' && value.trim().length > 0;
});

let auth = null;
let db = null;
let isFirebaseConfigured = hasRequiredFirebaseConfig;

// Resolves to the Messaging instance once browser support is confirmed, else null.
let messagingPromise = Promise.resolve(null);

if (!hasRequiredFirebaseConfig) {
  isFirebaseConfigured = false;
  console.warn('[Firebase] Config is missing — falling back to local mode.');
} else {
  try {
    const app = initializeApp(firebaseConfig);
    auth = getAuth(app);
    db = getFirestore(app);

    messagingPromise = isSupported()
      .then((supported) => (supported ? getMessaging(app) : null))
      .catch(() => null);
  } catch (error) {
    isFirebaseConfigured = false;
    auth = null;
    db = null;
    console.warn('[Firebase] Init failed — falling back to local mode.', error);
  }
}

export { auth, db, messagingPromise, isFirebaseConfigured };
